var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27148 14C7.7192 14 7.27148 13.5523 7.27148 13C7.27148 12.4477 7.7192 12 8.27148 12H13.2715C13.8238 12 14.2715 12.4477 14.2715 13C14.2715 13.5523 13.8238 14 13.2715 14H8.27148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27148 9C7.27148 9.55228 7.7192 10 8.27148 10H15.2715C15.8238 10 16.2715 9.55228 16.2715 9C16.2715 8.44772 15.8238 8 15.2715 8H8.27148C7.7192 8 7.27148 8.44772 7.27148 9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1151 19.152C12.274 19.0527 12.4577 19 12.6451 19H20.2715C21.3761 19 22.2715 18.1046 22.2715 17V5C22.2715 3.89543 21.3761 3 20.2715 3H4.27148C3.16691 3 2.27148 3.89543 2.27148 5V17C2.27148 18.1046 3.16691 19 4.27148 19H6.27148V21C6.27148 21.7854 7.13543 22.2643 7.80148 21.848L12.1151 19.152ZM11.5415 17.152L8.27148 19.1958V18C8.27148 17.4477 7.82377 17 7.27148 17H5.27148C4.7192 17 4.27148 16.5523 4.27148 16V6C4.27148 5.44772 4.7192 5 5.27148 5H19.2715C19.8238 5 20.2715 5.44772 20.2715 6V16C20.2715 16.5523 19.8238 17 19.2715 17H12.0715C11.8841 17 11.7004 17.0527 11.5415 17.152Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentText);
export default __webpack_public_path__ + "static/media/comment-text.0aabe5426b5ccab4e9c72643dffa7d47.svg";
export { ForwardRef as ReactComponent };